import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from './routes';
import Nav from './components/nav/nav';
import './App.css';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-161994278-1');
ReactGA.pageview(window.location.pathname + window.location.search);

export default function App() {
  return (
    <Router>
			<Nav />
			<Routes />
    </Router>
  );
}
